import React, { Component } from 'react'
import PropTypes from 'prop-types'
import actions from 'redux/actions'
import constants from 'common/helpers/constants'
import { FormattedMessage } from 'sb-react-intl'

import Offers from 'components/Offers/Offers'
import Modal from 'components/modal/Modal/Modal'

import messages from './messages'
import s from './ChooseGiftCardValueModal.scss'


const giftCardValues = [
  {
    size: 50,
    price: '50',
  },
  {
    size: 75,
    price: '75',
  },
  {
    size: 100,
    price: '100',
  },
  {
    size: 200,
    price: '200',
  },
]

class ChooseGiftCardValueModal extends Component {

  static propTypes = {
    data: PropTypes.shape({
      onNext: PropTypes.func.isRequired,
    }),
    name: PropTypes.string,
    onClose: PropTypes.func,
  }

  static defaultProps = {
    name: constants.modals.gifts.ChooseGiftCardValue,
  }

  handleClose = () => {
    const { name, onClose } = this.props

    actions.models.modals.close(name)

    if (typeof onClose === 'function') {
      onClose()
    }
  }

  handleChoosePrice = ({ price }) => {
    const { data: { onNext } } = this.props

    this.handleClose()
    onNext(price)
  }

  render() {
    const { name } = this.props

    return (
      <Modal className={s.chooseGiftCardValueModal} name={name} onClose={this.handleClose}>
        <FormattedMessage className={s.title} tag="div" {...messages.title} />
        <FormattedMessage className={s.hint} tag="div" {...messages.hint} />
        <Offers
          className={s.offers}
          itemClassName={s.offersItem}
          placement="giftSize"
          items={giftCardValues}
          bestSize={100}
          offerTitle="card"
          onChoose={this.handleChoosePrice}
        />
      </Modal>
    )
  }
}


export default ChooseGiftCardValueModal
